import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { IUser } from '../models';
import { SERVICES_API } from '../tokens';

@Injectable({
  providedIn: 'root',
})
export class UserService {
  constructor(
    @Inject(SERVICES_API)
    private readonly _servicesApi: string,
    private readonly _httpClient: HttpClient,
  ) {}

  /**
   * Logout user. Destroy session.
   */
  public logout(): Observable<void> {
    return this._httpClient.get<void>(`${this._servicesApi}/pro/logout`, {
      withCredentials: true,
    });
  }

  /**
   * Get logged user details.
   */
  public getMe(): Observable<IUser> {
    return this._httpClient.get<IUser>(`${this._servicesApi}/pro/client/me`, {
      withCredentials: true,
    });
  }
}
